import basicAppConfig from "@next-platform/client-common-core/infra/constants/basicAppConfig";

import { APPLICATIONS_ID } from "@/constants";

export function useBrand() {
  const applicationId = basicAppConfig.applicationId;
  const isSpicyChat = applicationId === APPLICATIONS_ID.SpicyChat;
  const isPixelChat = applicationId === APPLICATIONS_ID.PixelChat;
  const isSecretMate = applicationId === APPLICATIONS_ID.SecretMate;
  const isAdultTime = applicationId === APPLICATIONS_ID.AdultTime;
  const isEvilAngel = applicationId === APPLICATIONS_ID.EvilAngel;
  const isAsgMax = applicationId === APPLICATIONS_ID.AsgMax;

  return { isSpicyChat, isPixelChat, isSecretMate, isAdultTime, isEvilAngel, isAsgMax };
}
